
/**
 * Always use as first child of form, otherwise MultiSelects in the form behave weirdly.
 * @constructor
 */
export const SubmitFormOnEnter = () => <input hidden type="submit" />;
